/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Scroll To Top
 */

import { MdOutlineArrowUpward } from "react-icons/md";

// nodejs library that concatenates strings
import classnames from 'classnames';

// Hook
import ToogleVisibility from "./toogleVisibility";

// Style
import './style.scss';

export default function ScrollToTop() {

    const visibility = ToogleVisibility();

    // Set the top cordinate to 0
    // make scrolling smooth
    const scrollToTop = () => {
        window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
        });
    };

    return (
        <div className={classnames('back-to-top', visibility)}>
            <i><MdOutlineArrowUpward onClick={scrollToTop} /></i>
        </div>
    );
}